<template>
  <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.37848 9.88738L14.5171 3.22102C15.5307 1.90606 14.5934 0 12.9331 0H2.93356C1.29785 0 0.353829 1.85668 1.31754 3.17834L6.17844 9.84472C6.96413 10.9222 8.56433 10.9436 9.37848 9.88738Z" fill="#A217AB"/>
  </svg>
</template>

<script>
export default {
  name: 'open-dropdown-icon'
}
</script>
